import React from 'react';

const Error = () => {
  return (
    <>
        <h2>Sorry, something went wrong.</h2>
    </>    
  );
};

export default Error;